import { SHARED_ANCHORS } from './anchors'
import type { IOnboardingStep } from '../../types/IOnboardingStep'

const { taskCard, ear } = SHARED_ANCHORS

/** Фрагмент «карточка задачи»: шаги по TaskCard внутри указанного контекста */
export function taskCardSteps(context: string): IOnboardingStep[] {
  return [
    { id: 'task.performer', anchors: [taskCard.performer], context, placement: 'bottom' },
    { id: 'task.deadline', anchors: [taskCard.deadline], context, placement: 'bottom' },
    { id: 'task.subtask', anchors: [taskCard.subtask], context, placement: 'bottom' },
    { id: 'task.observers', anchors: [taskCard.observers], context, placement: 'bottom' },
    { id: 'task.checklist', anchors: [taskCard.checklist], context, placement: 'bottom' },
    { id: 'task.menu', anchors: [taskCard.menu], context, placement: 'left' },
    { id: 'task.statusActions', anchors: [taskCard.statusActions], context, placement: 'top' },
  ]
}

/**
 * Фрагмент «ушки формы»: чат, документы-отчёты-ссылка одной группой, кнопка обучения.
 * На шаге чата дополнительно открыта область `chatPane` — учебная переписка в правой панели.
 */
export function earsSteps(context: string, scopes: string[]): IOnboardingStep[] {
  return [
    { id: 'ear.chat', anchors: [ear.chat, SHARED_ANCHORS.demoChat], context, scopes: [...scopes, 'chatPane'], placement: 'left' },
    { id: 'ear.files', anchors: [ear.document, ear.reports, ear.link], context, scopes, placement: 'left' },
    { id: 'ear.onboarding', anchors: [ear.onboarding], context, scopes, placement: 'left' },
  ]
}
